const framer = {
  transition: {},
  slidefromAbove: {},
  slidefromBelow: {},
  fade: {}
};

framer.transition= {
  type: "spring", 
  duration: 0.6, 
  bounce: 0
};



framer.slide = {
  animate: {
    y: 0,
    opacity: 1
  },
  initial: {
    y: 200,
    opacity: 0
  },
  exit: {
    y: -200,
    opacity: 0
  },
  transition: framer.transition
};


framer.slideInfromAbove = {
  animate: {
    y: 0,
    opacity: 1
  },
  initial: {
    y: -200,
    opacity: 0
  },
  transition: framer.transition
};

framer.slideInfromBelow = {
  animate: {
    y: 0,
    opacity: 1
  },
  initial: {
    y: 200,
    opacity: 0
  },
  transition: framer.transition
};

framer.fade = {
  animate: { 
    opacity: 1
  },
  initial: {
    opacity: 0
  },
  exit: {
    opacity: 0
  },
  transition: framer.transition
};

export default framer;